export interface IDepartment {
    id: number;
    name: string;
}

export const defaultDepartment: IDepartment = {
    id: 0,
    name: 'Developer'
}